import { FrontChat } from "components/FrontChat";
import { ChatSurfaceCoordinatorProvider } from "providers/ChatSurfaceCoordinator";

import { Appcues } from "../../components/Appcues";
import { Layout } from "../../components/Layout";
import { ScoutLaunchAnnouncement } from "./Scout/LaunchAnnouncement/ScoutLaunchAnnouncement";

export function Customer() {
  return (
    <ChatSurfaceCoordinatorProvider>
      <Appcues />
      <FrontChat />
      <ScoutLaunchAnnouncement />
      <Layout />
    </ChatSurfaceCoordinatorProvider>
  );
}
